import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";
import { showDialogOverlay, hideDialogOverlay } from "../../../utils/dialogOverlay.js";
import { renderUyeliklerGrid } from "../uyeliklerGrid.js";
import { uiState } from "../../../state/uiState.js";

const API = "/api";
let didBind = false;

function ensureUyeliklerDurumDialog() {
	if (document.getElementById("uyeliklerDurumDialog")) return;
	document.body.insertAdjacentHTML(
		"beforeend",
		`
<dialog id="uyeliklerDurumDialog">
	<div class="delete-dialog-container">
		<div class="delete-dialog-header">
			<div class="delete-header-icon kisiler-toggle-header-icon">
				<span class="material-icons uyelikler-durum-header-icon-inner" style="font-size:22px">person_off</span>
			</div>
			<h2 class="uyelikler-durum-title">Uyeligi Pasife Al</h2>
			<button class="delete-dialog-close">
				<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
					<line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
				</svg>
			</button>
		</div>
		<hr class="delete-divider" />
		<div class="delete-dialog-body">
			<p class="uyelikler-durum-body-text">Bu uyeligi pasife almak istediginizden emin misiniz?</p>
			<div class="delete-dialog-card">
				<div class="delete-card-icon">
					<span class="material-icons" style="font-size:20px;color:#6b7280">badge</span>
				</div>
				<div class="delete-card-info">
					<span class="delete-dialog-id uyelikler-durum-tc">—</span>
					<span class="delete-dialog-name uyelikler-durum-name">—</span>
					<span class="uyelikler-durum-email">—</span>
				</div>
			</div>
			<div class="kisiler-toggle-warning delete-dialog-warning">
				<span class="material-icons kisiler-toggle-warning-icon uyelikler-durum-warning-icon" style="font-size:17px;flex-shrink:0;margin-top:1px">info</span>
				<span class="uyelikler-durum-warning-text">Uyelik sistemde pasif olarak isaretlenecektir.</span>
			</div>
		</div>
		<div class="delete-dialog-buttons">
			<button class="delete-cancel">Iptal</button>
			<button class="delete-confirm uyelikler-durum-confirm-btn">
				<span class="material-icons uyelikler-durum-confirm-icon" style="font-size:16px">person_off</span>
				<span class="uyelikler-durum-confirm-text">Pasife Al</span>
			</button>
		</div>
	</div>
</dialog>`,
	);
}

function syncDialogAppearance(dialog, isActive) {
	const headerIcon = dialog.querySelector(".kisiler-toggle-header-icon");
	const headerIconInner = dialog.querySelector(".uyelikler-durum-header-icon-inner");
	const warning = dialog.querySelector(".delete-dialog-warning");
	const warningIcon = dialog.querySelector(".uyelikler-durum-warning-icon");
	const confirmBtn = dialog.querySelector(".uyelikler-durum-confirm-btn");
	const confirmIcon = dialog.querySelector(".uyelikler-durum-confirm-icon");

	if (isActive) {
		headerIcon.style.background = "#fef3c7";
		headerIconInner.textContent = "person_off";
		headerIconInner.style.color = "#d97706";
		dialog.querySelector(".uyelikler-durum-title").textContent = "Uyeligi Pasife Al";
		dialog.querySelector(".uyelikler-durum-body-text").textContent = "Bu uyeligi pasife almak istediginizden emin misiniz?";
		warning.style.background = "#fffbeb";
		warning.style.borderLeftColor = "#f59e0b";
		warning.style.color = "#92400e";
		warningIcon.textContent = "pause_circle";
		dialog.querySelector(".uyelikler-durum-warning-text").textContent = "Uyelik pasif olarak isaretlenecek, giris yapamayacaktir.";
		confirmBtn.style.background = "#f59e0b";
		confirmBtn.style.borderColor = "#f59e0b";
		confirmIcon.textContent = "person_off";
		dialog.querySelector(".uyelikler-durum-confirm-text").textContent = "Pasife Al";
		return;
	}

	headerIcon.style.background = "#dcfce7";
	headerIconInner.textContent = "how_to_reg";
	headerIconInner.style.color = "#16a34a";
	dialog.querySelector(".uyelikler-durum-title").textContent = "Uyeligi Aktife Al";
	dialog.querySelector(".uyelikler-durum-body-text").textContent = "Bu uyeligi aktife almak istediginizden emin misiniz?";
	warning.style.background = "#f0fdf4";
	warning.style.borderLeftColor = "#22c55e";
	warning.style.color = "#166534";
	warningIcon.textContent = "check_circle";
	dialog.querySelector(".uyelikler-durum-warning-text").textContent = "Uyelik aktif olarak isaretlenecek, giris yapabilecektir.";
	confirmBtn.style.background = "#22c55e";
	confirmBtn.style.borderColor = "#22c55e";
	confirmIcon.textContent = "how_to_reg";
	dialog.querySelector(".uyelikler-durum-confirm-text").textContent = "Aktife Al";
}

function showToast(message, type = "success") {
	Toastify({
		text: message,
		duration: 3000,
		gravity: "top",
		position: "right",
		stopOnFocus: true,
		style: {
			background: type === "success" ? "#22c55e" : "#ee4447",
			borderRadius: "8px",
			fontSize: "14px",
			fontWeight: "500",
		},
	}).showToast();
}

export function initUyeliklerDurumDialog() {
	ensureUyeliklerDurumDialog();
	const dialog = document.querySelector("#uyeliklerDurumDialog");
	if (!dialog || didBind) return;
	didBind = true;

	let pendingId = null;
	let pendingIsActive = true;
	let pendingEmail = "";
	let pendingYetkiId = null;

	window.openUyeliklerDurumDialog = async (id, fallbackLabel, isActive) => {
		pendingId = id;
		pendingIsActive = isActive;
		pendingEmail = "";
		pendingYetkiId = null;

		dialog.querySelector(".uyelikler-durum-tc").textContent = "—";
		dialog.querySelector(".uyelikler-durum-name").textContent = fallbackLabel ?? "—";
		dialog.querySelector(".uyelikler-durum-email").textContent = "—";
		syncDialogAppearance(dialog, isActive);
		dialog.showModal();

		showDialogOverlay(dialog, "Yukleniyor...");
		await new Promise((resolve) => setTimeout(resolve, 350));
		try {
			const res = await fetch(`${API}/uyeler/${encodeURIComponent(id)}`);
			const data = await res.json();
			if (!data.ok) throw new Error(data.error || `HTTP ${res.status}`);
			pendingEmail = data.email ?? "";
			pendingYetkiId = data.yetki_id ?? null;
			dialog.querySelector(".uyelikler-durum-tc").textContent = data.kisi_tc ?? "—";
			dialog.querySelector(".uyelikler-durum-name").textContent = `${data.first_name ?? ""} ${data.last_name ?? ""}`.trim() || fallbackLabel || "—";
			dialog.querySelector(".uyelikler-durum-email").textContent = data.email ?? "—";
		} catch (err) {
			console.error("❌ Uyelik durum dialog verisi yuklenemedi:", err);
			showToast("Uyelik bilgileri yuklenemedi.", "error");
			dialog.close();
		} finally {
			hideDialogOverlay();
		}
	};

	dialog.addEventListener("click", (e) => {
		if (e.target.closest(".delete-dialog-close") || e.target.closest(".delete-cancel")) {
			dialog.close();
		}
	});

	dialog.querySelector(".delete-confirm").addEventListener("click", async () => {
		if (!pendingId || !pendingEmail || !pendingYetkiId) return;
		const newIsActive = pendingIsActive ? 0 : 1;

		showDialogOverlay(dialog, "Guncelleniyor...");
		await new Promise((resolve) => setTimeout(resolve, 350));
		try {
			const res = await fetch(`${API}/uyeler/${encodeURIComponent(pendingId)}`, {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					email: pendingEmail,
					yetki_id: pendingYetkiId,
					is_active: newIsActive,
				}),
			});
			const data = await res.json();
			if (!data.ok) throw new Error(data.error || `HTTP ${res.status}`);

			dialog.close();
			showToast(newIsActive === 0 ? "Uyelik pasife alindi." : "Uyelik aktife alindi.");
			const refreshUrl = uiState.uyelikler.lastSearchUrl ?? `${API}/uyeler`;
			renderUyeliklerGrid({
				url: refreshUrl,
				paginationLimit: uiState.uyelikler.paginationLimit,
			});
		} catch (err) {
			console.error("❌ Uyelik durum degisikligi hatasi:", err);
			showToast(err.message || "Islem sirasinda hata olustu.", "error");
		} finally {
			hideDialogOverlay();
		}
	});
}
